import { z } from 'zod';
/**
 * Mirrors `@Transform(({ value }) => value === 'true' || value === true)` for
 * query-string booleans, while preserving `undefined` when the param is absent
 * (so an omitted flag stays optional rather than becoming `false`).
 */
export const coercedBoolean = () => z.preprocess((v) => (v === undefined ? undefined : v === 'true' || v === true), z.boolean().optional());
/**
 * TanStack Router serializes `arr=[a]` as `?arr=a` (a single value), so a query
 * array param must accept both shapes. Coerces a single value to a one-element
 * array; treats falsy/absent as `undefined`. Matches the legacy
 * `@Transform(v => Array.isArray(v) ? v : v ? [v] : undefined)`.
 */
export const optionalStringArray = () => z.preprocess((v) => {
    if (Array.isArray(v))
        return v;
    return v ? [v] : undefined;
}, z.array(z.string()).optional());
/**
 * Generic single-value-to-array query coercion over an arbitrary item schema
 * (e.g. an enum). Null/undefined stay absent; a single value becomes a
 * one-element array. Mirrors the stats-bo `ToArray` transform.
 */
export const coercedArray = (item) => z.preprocess((v) => {
    if (v === undefined || v === null)
        return;
    return Array.isArray(v) ? v : [v];
}, z.array(item).optional());
/**
 * Mirrors `@Transform(({ value }) => (value === '' ? null : value))` on an
 * optional + nullable field: coerces an empty string to `null`, otherwise
 * validates with `schema`. Absent stays `undefined`.
 */
export const emptyStringToNull = (schema) => z.preprocess((v) => (v === '' ? null : v), schema.nullish());
/**
 * Coerced, defaulted pagination params shared across list-query DTOs
 * (replaces the legacy `@Transform(v => v ? parseInt(v, 10) : N)` + `@Min/@Max`).
 */
export const pageParam = (defaultValue = 1) => z.coerce.number().int().min(1).default(defaultValue);
export const pageSizeParam = (defaultValue = 20, max = 100) => z.coerce.number().int().min(1).max(max).default(defaultValue);
